/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown>, total: NonNullable<unknown> }} Chat_Blob_Version_LatestInputs */



/**
* | output |
* | --- |
* | "Latest version ({index} of {total})" |
*
* @param {Chat_Blob_Version_LatestInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_blob_version_latest = /** @type {((inputs: Chat_Blob_Version_LatestInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Blob_Version_LatestInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Neueste Version (${i?.index} von ${i?.total})`)
	return /** @type {LocalizedString} */ (`Latest version (${i?.index} of ${i?.total})`)
});